import React, { useRef } from 'react'

import { MinusCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
import './index.scss'
import { deleteModule, setActiveModule, componentSort } from '../../store/actions'
import { connect } from 'react-redux'

export interface IOutLineProps {
  activeId?: string
  id: string
  pid: string
  children: React.ReactNode
  deleteActive: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  setActive: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  componentChangeSort: (pid: string, index: number, isUp: boolean) => void
  tree: any
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deleteActive: e => {
      dispatch(deleteModule(ownProps.id, ownProps.pid))
      e.stopPropagation()
    },
    setActive: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      dispatch(setActiveModule(ownProps.id, ownProps.pid, ownProps.children.props.render))

      event.stopPropagation()
    },
    //TODO tab下组件并未分成不同的tab组，显示向上下的按钮有误差
    componentChangeSort: (pid: string, index: number, isUp: boolean) => {
      dispatch(componentSort(pid, index, isUp))
    },
  }
}
const mapStateToProps = (state: any) => {
  return {
    activeId: state.panes.activeId === 'root' ? '' : state.panes.activeId,
    tree: state.tree,
  }
}

const OutLine = (props: IOutLineProps) => {
  const { activeId, id, pid, children, deleteActive, setActive, componentChangeSort, tree } = props
  const pchil = (tree[pid] && tree[pid].childrens) || []
  const elIndex = (pchil && pchil.indexOf(id) !== -1 && pchil.indexOf(id)) || 0
  const ref: React.MutableRefObject<any> = useRef()
  // TODO 对不同组件控制显示placeholder的抽象分离
  const judgment = props => {
    let state
    switch (props.render) {
      case 'ProductList':
        if (props.config.products && props.config.products.length > 0) {
          state = true
        }
        break
      case 'ImageBox':
        if (props.config.images && props.config.images.length > 0) {
          state = true
        }
        break
      case 'AnchorTabs':
        if (props.config.tabs && props.config.tabs.length > 0) {
          state = true
        }
        break
      case 'VideoBox':
        if (props.config.videoSrc) {
          state = true
        }
        break
      case 'TextBox':
        if (props.config.text) {
          state = true
        }
        break
      case 'MixedBlocks':
        if (props.config) {
          state = true
        }
        break
      case 'CustomTitle':
        if (props.config) {
          state = true
        }
        break
      case 'SearchBar':
        state = true
        break
      case 'Conference':
        if (props.config.tabs && props.config.tabs[0].tabUrl) state = true
        break
      case 'NoticeBar':
        if (props.config.list && props.config.list.length) state = true
        break
      case 'CombinationList':
        if (props.config.combinations && props.config.combinations.length) state = true
        break
      case 'Block':
        props.config?.href && (state = true)
        break
      default:
        state = false
        break
    }
    return state
  }

  const setActiveModule = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!ref || id === 'root') {
      return
    }
    const childOutlines = ref.current.querySelectorAll('.out_line_container')
    if (!childOutlines || childOutlines.length === 0) {
      setActive(event)
    } else {
      const isOnlyClickOnContainer = Array.from(childOutlines)
        .map((childOutline: any) => {
          const { top, bottom, left, right } = childOutline.getBoundingClientRect()
          if (
            top < event.clientY &&
            event.clientY < bottom &&
            left < event.clientX &&
            event.clientX < right
          ) {
            childOutline.click()
            return true
          }
          return false
        })
        .reduce((a, c) => a && c)
      if (!isOnlyClickOnContainer && id !== activeId) {
        setActive(event)
      }
    }
  }

  let childConfigs = React.Children.map(children, (c: any) => {
    if (
      !c.props ||
      !c.props.config ||
      Object.keys(c.props.config).length === 0 ||
      !judgment(c.props)
    ) {
      return null
    }
    return c.props.config
  })
  childConfigs = childConfigs && childConfigs.filter(config => config != null)
  return (
    <div ref={ref} className="out_line_container" onClick={setActiveModule}>
      {children}
      {id !== 'root' && childConfigs && childConfigs.length === 0 && (
        <div className="out_line_placeholder"> PLACEHOLDER </div>
      )}
      {activeId === id && <div className="out_line_selected" />}

      {activeId === id && (
        <div className="delete" onClick={deleteActive}>
          <MinusCircleOutlined className="deleteIcon" />
        </div>
      )}
      {activeId === id && elIndex !== 0 && (
        <div className="upwardContent" onClick={() => componentChangeSort(pid, elIndex, true)}>
          <UpOutlined />
        </div>
      )}
      {activeId === id && pchil && elIndex !== pchil.length - 1 && (
        <div
          className="downContent"
          onClick={() => {
            componentChangeSort(pid, elIndex, false)
          }}
        >
          <DownOutlined />
        </div>
      )}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(OutLine)
